import kebabCase from 'lodash/kebabCase'
import moment from 'moment'
import {
    useCallback,
} from 'react'
import {
    useDispatch,
} from 'react-redux'
import DTOSpec from 'app/Apps/Pricing/ContractBasis/dtoSpec'
import useQuoteGenerate from 'app/Apps/Pricing/ContractBasis/hooks/useQuoteGenerate'
import Button from 'app/shared-components/Button'
import {
    successedToSaveForm,
} from 'app/shared-components/FormStatuses/store/formStatuses.slice'
import downloadDocument from 'app/utils/downloadDocument'
import {
    ContractBasis,
} from 'app/Apps/Pricing/Pricing.types'
import ContractBasisCreateQuote from './ContractBasisDemoCreateQuote'

const ContractBasisDemoCreateQuoteContainer = ({
    data,
}: Readonly<{
    data: ContractBasis,
    onSuccess?: () => void,
    onCancel?: () => void,
    backPath?: string,
}>) => {
    const dispatch = useDispatch()
    const onGenerateSuccess = useCallback((responseData, locationName, companyName) => {
        const fileName = `${moment().format('YYYYMMDD')}${locationName ? `_${kebabCase(locationName)}` : ''}${companyName ? `_${kebabCase(companyName)}` : ''}`

        downloadDocument(responseData, fileName)
        dispatch(
            successedToSaveForm({
                id: 'Notification',
                title: 'The Lane Quote has been successfully downloaded.',
            }),
        )
    }, [dispatch])

    const {
        mutate: generate,
    } = useQuoteGenerate({
        locationName: data?.customerQuotation?.locationName,
        companyName: data?.account?.company?.companyName,
        request: DTOSpec.ContractBasis.QuotePrint.GenerateRequest,
        onSuccess: onGenerateSuccess,
    })
    const generatePDFCall = useCallback((params) => {
        generate({
            ...params,
        })
    }, [generate])

    const renderButtons = useCallback((params) => {
        return (
            <Button
                label="Submit"
                onClick={() => {
                    return generatePDFCall(params)
                }}
            />
        )
    }, [generatePDFCall])

    return (
        <ContractBasisCreateQuote
            id={Number(data?.id)}
            renderActions={renderButtons}
        />
    )
}

export default ContractBasisDemoCreateQuoteContainer
